import { useLocalSearchParams } from 'expo-router';

const LIVE_THREAD_POLLING_INTERVAL_MS = 1500;

/** Maps a poll flag to a react-query refetchInterval. */
const getThreadRefetchInterval = (shouldPoll: boolean): number | false =>
    shouldPoll ? LIVE_THREAD_POLLING_INTERVAL_MS : false;

/** True when the thread detail page was opened with `?live=1`. */
const useIsLiveThread = (): boolean => {
    const { live } = useLocalSearchParams<{ live?: string }>();
    return live === '1';
};

/**
 * Shared refetchInterval for AI thread detail tabs.
 * Polls when the page is in live mode, and optionally when `additionalShouldPoll` is true
 * (e.g. while an eval is running on the Scores tab).
 */
export const useLiveThreadRefetchInterval = ({
    additionalShouldPoll = false,
}: {
    additionalShouldPoll?: boolean;
} = {}): number | false => {
    const isLive = useIsLiveThread();
    return getThreadRefetchInterval(isLive || additionalShouldPoll);
};
